<template>
  <div id="app" class="electron-app">
    <div class="electron-container">
      <!-- 标题栏 -->
      <div class="electron-title-bar">
        <h1 class="electron-title">平台账号管理</h1>
      </div>

      <!-- 主容器 -->
      <div class="electron-main">
        <!-- 按钮区域 -->
        <div class="button-group">
          <div class="left-buttons">
            <el-button type="primary" size="small" @click="handleAdd">
              <i class="el-icon-plus"></i> 新增账号
            </el-button>
            <el-button type="primary" size="small" @click="handleStartTask" v-if="!is_running">
              <i class="el-icon-video-play"></i> 开始任务
            </el-button>
            <el-button type="danger" size="small" @click="stopTask" v-else>
              <i class="el-icon-video-pause"></i> 停止任务
            </el-button>
          </div>

          <div class="search-box">
            <el-input v-model="customer" size="small" placeholder="指定客户名称..." prefix-icon="el-icon-search" clearable
              :disabled="is_running"></el-input>
          </div>
          <div class="checkbox-box">
            <el-checkbox v-model="showChild" @change="changeShowChild" :disabled="is_running">显示任务界面</el-checkbox>
          </div>
          <div>
            <el-button type="" size="small" @click="handleReload">
              <i class="el-icon-refresh"></i> 刷新
            </el-button>
          </div>
        </div>

        <!-- 表格区域 -->
        <div class="table-wrapper">
          <el-table :data="accountList" border stripe size="small" style="width: 100%">
            <!-- 序号列 -->
            <el-table-column type="index" label="序号" width="60" align="center" />

            <!-- 平台名称 -->
            <el-table-column prop="platform" label="平台名称" min-width="100" align="left">
              <template slot-scope="scope">
                <span class="platform-badge">{{ platformMap[scope.row.platform] }}</span>
              </template>
            </el-table-column>

            <!-- 手机号 -->
            <el-table-column prop="phone" label="手机号" min-width="130" align="center" />

            <!-- 授权状态 -->
            <el-table-column prop="auth" label="授权状态" min-width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.auth ? 'success' : 'danger'">
                  {{ scope.row.auth ? '已授权' : '未授权' }}
                </el-tag>
              </template>
            </el-table-column>

            <!-- 计数 -->
            <el-table-column prop="count" label="计数" min-width="80" align="center" />

            <!-- 授权时间 -->
            <el-table-column prop="auth_time" label="授权时间" min-width="160" align="center" />

            <!-- 操作列 -->
            <el-table-column label="操作" min-width="150" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="handleAuth(scope.row)">
                  授权
                </el-button>
                <el-button type="danger" size="mini" @click="handleDelete(scope.$index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 消息滚动区域 -->
      <div class="log-section">
        <div class="log-header">
          <i class="el-icon-document"></i> 任务日志输出
        </div>
        <div class="log-wrapper">
          <textarea :placeholder="is_running ? '任务执行中...' : '等待任务执行...'" v-model="textarea" class="custom-textarea"
            spellcheck="false" readonly></textarea>
        </div>
      </div>
    </div>

    <!-- 编辑对话框 -->
    <el-dialog title="添加账号信息" :visible.sync="dialogVisible" width="400px" @close="resetForm">
      <el-form :model="editForm" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="平台名称" prop="platform">
          <el-select v-model="editForm.platform" placeholder="选择平台">
            <el-option :label="label" :value="value" v-for="(label, value) in platformMap" :key="value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="editForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { sendExec } from '@/assets/js/index.js'
import dayjs from 'dayjs'
const { ipcRenderer } = window.require('electron')

export default {
  name: 'Index',
  data() {
    return {
      platformMap: {
        'douyin': '抖音',
        'doubao': '豆包',
        'deepseek': 'DeepSeek',
        'qianwen': '千问',
        'baidu': '百度',
      },
      accountList: [],
      dialogVisible: false,
      editForm: {
        platform: '',
        phone: ''
      },
      rules: {
        platform: [
          { required: true, message: '请选择平台名称', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur' }
        ]
      },
      textarea: '',
      timer: null,
      is_running: false,
      customer: null,
      showChild: false,
    }
  },
  async created() {
    ipcRenderer.removeAllListeners();
    ipcRenderer.on('message', async (event, message) => {
      this.textarea = message + '\n' + this.textarea;
      if (message.includes('授权失效') || message.includes('达标')) {
        await this.loadAccountList();
      }
      if (message.includes('= END =')) {
        this.is_running = false;
        localStorage.setItem('is_running', 'false');
      }
    });

    this.loadAccountList();
    this.is_running = localStorage.getItem('is_running') === 'true';
  },
  methods: {
    //加载账号列表
    async loadAccountList() {
      const result = await sendExec('getAllAccounts', null)
      this.accountList = result
    },

    // 新增账号
    handleAdd() {
      this.editForm = {
        platform: '',
        phone: ''
      }
      this.dialogVisible = true
    },

    //授权账号
    async handleAuth(row) {
      const result = await sendExec('authAccount', row)
      if (result.success) {
        this.$message.success('授权成功')
        await this.loadAccountList();
      } else {
        this.$message.error(result.message || '授权失败')
      }
    },

    //删除账号
    handleDelete(index) {
      this.$confirm('确定删除这条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const id = this.accountList[index]._id
        await sendExec('deleteAccount', id)
        await this.loadAccountList()
      }).catch(() => { })
    },

    //提交表单
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const result = await sendExec('addAccount', this.editForm)
          if (result.success) {
            this.$message.success('账号添加成功')
            this.dialogVisible = false
            await this.loadAccountList()
          } else {
            this.$message.error(result.message || '账号添加失败')
          }
        }
      })
    },

    //重置表单
    resetForm() {
      this.$refs.form.clearValidate()
    },

    //开始任务
    async handleStartTask() {
      this.$confirm('确定开始执行任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.textarea = '';
        let result = await sendExec('startTask', { customer: this.customer?.trim() || null, showChild: this.showChild })
        if (result.success) {
          this.is_running = true;
          localStorage.setItem('is_running', 'true');
        } else {
          this.$message.error(result.msg);
        }

      }).catch(() => { })
    },

    //结束任务
    async stopTask() {
      await sendExec('stopTask', null)
      this.$message.warning('任务正在停止...')
    },

    //展示或隐藏子窗口
    async changeShowChild() {
      await sendExec('changeShowChild', this.showChild);
    },

    //刷新
    handleReload() {
      location.reload(true);
    }

  }
}
</script>